<p-messages severity="info" styleClass="m-2">
    <ng-template pTemplate>
        <div style="font-size: normal" class="p-2">
            The eFAACT - GovConPay validation process identifies data anomalies prior to activating the unified
            solution. Before a “live” import from GovConPay, employee names must be identical in both software
            applications, including middle initial and spaces. The same requirement applies to Payroll Item. The
            validation results include the original source of the data (QuickBooks or GovConPay) and are presented with
            one or more lines per employee.
            <ol>
                <li>Two lines for an employee indicates the names do not match between applications. Correct the
                    discrepancy in GovConPay ensuring it matches exactly to the QB source name. </li>
                <li>One line with a QB source indicates the person does not exist in GovConPay. This can be considered a
                    valid situation if the employee was INTENTIONALLY EXCLUDED from the GovConPay implementation. </li>
                <li>One line with source GCP indicates the person does not exist in eFAACT but has been setup in
                    GovConPay. This person will be setup as a new employee in eFAACT and QuickBooks. This can be
                    considered a valid situation if the new employee NEVER existed in QuickBooks. </li>

            </ol>
            After resolving or accepting the validation discrepancies, re-run the Validation process and review the
            updated results. Repeat this step until all discrepancies have been properly addressed.
            Once all names are acceptable, click CONFIRM to the sign the accepted results and activate the GovConPay
            interface.
            Next step is to click the Employee Import button to complete the initial “live” GovConPay employee import.
            <div class="button-bar">
                <div>
                    <span class="label">Last Sync lists:</span>
                    <span>{{
                        validSyncLists
                        ? moment(lastSyncLists).format('YYYY-MM-DD HH:mm')
                        : ''
                        }}</span>
                </div>
                <div>
                    <span class="label">Last Validation:</span>
                    <span>{{
                        validLastValidation
                        ? moment(lastValidationRun).format(
                        'YYYY-MM-DD HH:mm'
                        )
                        : ''
                        }}</span>
                </div>
                <!-- <div>
                <span class="label">Name Order:</span
                ><span>{{ nameOrder ?? 'NONE!!' }}</span>
            </div> -->
            </div>
        </div>
    </ng-template>
</p-messages>
<p-toolbar [hidden]="loading">
    <button pButton label="Run Validation"
        title="Compares existing eFAACT employee names to GCP employee names to confirm all match identically"
        class="p-button-success" (click)="Validate.emit()" [disabled]="IsValidationComplete"></button>
    <button pButton label="Confirm" title="Accept Employee and Payroll names and enable the eFAACT GovConPay Interface"
        class="p-button-success" [disabled]="IsValidationComplete" (click)="Complete.emit()"></button>
    <div class="flex items-center" [hidden]="!IsAdmin()">
        <p-checkbox #showAll binary="true"></p-checkbox>
        <label for="showAll" class="ml-2">Show Tech Support Fields</label>
    </div>
</p-toolbar>

<p-tabs #tabActions value="0">
    <p-tablist>
        <p-tab value="0">Employee</p-tab>
        <p-tab value="1">Payroll</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="0">
            <button type="button" pButton class="p-button-secondary" pTooltip="Download" icon="pi pi-download"
                (click)="dtEmployees.exportCSV()" style="margin-bottom: 0.5em"></button>
            <p-table stripedRows [value]="employees" dataKey="id" scrollHeight="35vh" [scrollable]="true" #dtEmployees
                [columns]="employeecols" sortField="LastName" exportFilename="EmployeeValidation">
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span>No Discrepancies Found</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #header let-item>
                    <tr class="column-header">
                        <!-- EmployeeName -->
                        <th class="p-header-cell small-cell" pSortableColumn="EmployeeName">
                            Employee Name
                            <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="EmployeeName" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- FirstName -->
                        <th class="p-header-cell small-cell" pSortableColumn="FirstName">
                            First Name
                            <p-sortIcon field="FirstName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="FirstName" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- MiddleName -->
                        <th class="p-header-cell small-cell" pSortableColumn="MiddleName">
                            Middle Name
                            <p-sortIcon field="MiddleName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="MiddleName" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- LastName -->
                        <th class="p-header-cell small-cell" pSortableColumn="LastName">
                            Last Name
                            <p-sortIcon field="LastName" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="LastName" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- Source -->
                        <th class="p-header-cell small-cell" pSortableColumn="source">
                            Source
                            <p-sortIcon field="source" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="source" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- IsActive -->
                        <th class="p-header-cell small-cell" pSortableColumn="IsActive" [hidden]="!showAll.checked">
                            Active
                            <p-sortIcon field="IsActive" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="IsActive" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- Id -->
                        <th class="p-header-cell small-cell" pSortableColumn="id" [hidden]="!showAll.checked">
                            Id
                            <p-sortIcon field="id" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="id" display="menu"
                                class="ml-auto" />
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-item>
                    <tr class="tabulator-row p-selectable-row" [pEditableRow]="item"
                        [pEditableRowDisabled]="item.IsReadOnly">
                        <!-- EmployeeName -->
                        <td class="p-datatable-cell">
                            {{ item?.EmployeeName }}
                        </td>
                        <!-- FirstName -->
                        <td class="p-datatable-cell">
                            {{ item?.FirstName }}
                        </td>
                        <!-- MiddleName -->
                        <td class="p-datatable-cell">
                            {{ item?.MiddleName }}
                        </td>
                        <!-- LastName -->
                        <td class="p-datatable-cell">
                            {{ item?.LastName }}
                        </td>
                        <!-- Source -->
                        <td class="p-datatable-cell">
                            {{ item?.source }}
                        </td>
                        <!-- IsActive -->
                        <td class="p-datatable-cell" [hidden]="!showAll.checked">
                            {{ item?.IsActive }}
                        </td>
                        <!-- Id -->
                        <td class="p-datatable-cell" [hidden]="!showAll.checked">
                            {{ item?.id }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabpanel>
        <p-tabpanel value="1">
            <button type="button" pButton class="p-button-secondary" pTooltip="Download" icon="pi pi-download"
                    (click)="dtPaycodes.exportCSV()" style="margin-bottom: 0.5em"></button>
            <p-table stripedRows [value]="paycodes" dataKey="id" scrollHeight="35vh" [scrollable]="true" #dtPaycodes
                [columns]="payrollcols" sortField="Title" exportFilename="PaycodeValidation">
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span>No Discrepancies Found</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #header let-item>
                    <tr class="column-header">
                        <!-- Title -->
                        <th class="p-header-cell small-cell" pSortableColumn="Title">
                            Title
                            <p-sortIcon field="Title" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="Title" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- Type -->
                        <th class="p-header-cell small-cell" pSortableColumn="Type">
                            Type
                            <p-sortIcon field="Type" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="Type" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- PayCode -->
                        <th class="p-header-cell small-cell" pSortableColumn="PayCode">
                            PayCode
                            <p-sortIcon field="PayCode" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="PayCode" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- Source -->
                        <th class="p-header-cell small-cell" pSortableColumn="source">
                            Source
                            <p-sortIcon field="source" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="source" display="menu"
                                class="ml-auto" />
                        </th>
                        <!-- Id -->
                        <th [hidden]="!showAll.checked" class="p-header-cell small-cell" pSortableColumn="id">
                            Id
                            <p-sortIcon field="id" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                            <p-columnFilter type="text" matchMode="contains" field="id" display="menu"
                                class="ml-auto" />
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-item>
                    <tr class="tabulator-row p-selectable-row" [pEditableRow]="item"
                        [pEditableRowDisabled]="item.IsReadOnly">
                        <!-- Title -->
                        <td class="p-datatable-cell">
                            {{ item?.Title }}
                        </td>
                        <!-- Type -->
                        <td class="p-datatable-cell">
                            {{ item?.Type }}
                        </td>
                        <!-- PayCode -->
                        <td class="p-datatable-cell">
                            {{ item?.PayCode }}
                        </td>
                        <!-- Source -->
                        <td class="p-datatable-cell">
                            {{ item?.source }}
                        </td>
                        <!-- Id -->
                        <td class="p-datatable-cell" [hidden]="!showAll.checked">
                            {{ item?.id }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
